module.exports = __webpack_public_path__ + "img/healthidv.7a13f871.svg";